var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SysnotificationService } from './sysnotification.service';
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { LocalService } from './local.service';
import { SessionService } from './session.service';
import * as i0 from "@angular/core";
import * as i1 from "./session.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./auth.service";
import * as i4 from "./local.service";
import * as i5 from "@angular/router";
import * as i6 from "./sysnotification.service";
var AgentService = /** @class */ (function () {
    function AgentService(sessionService, http, _authService, localService, router, sysNotification) {
        this.sessionService = sessionService;
        this.http = http;
        this._authService = _authService;
        this.localService = localService;
        this.router = router;
        this.sysNotification = sysNotification;
        this.AllAvailableAgentsList = []; // All available agents by all topics
        this.topicIds = [];
        this.transferContactModal = new EventEmitter();
        this.cancelFeedbackUpdate = new EventEmitter();
        this.saveFeedBackEvent = new EventEmitter();
        this._agentSessionStatus = new BehaviorSubject({ id: 5, name: "undefined" });
        this.agentSessionStatus$ = this._agentSessionStatus.asObservable();
        this._enableStartChatButton = new BehaviorSubject(false);
        this.enableStartChatButton$ = this._enableStartChatButton.asObservable();
        this._companyTopicList = new BehaviorSubject([]);
        this.companyTopicList$ = this._companyTopicList.asObservable();
        // Fires on each socket `connect` so views can re-join rooms and re-query status after a (re)connect.
        this._onConnect = new Subject();
        this.onConnect$ = this._onConnect.asObservable();
        this._editing = false;
        this.agentsResolved = [];
        this._cachedAgent = null;
        this._cachedAgentId = null;
        this._hasConnectedOnce = false;
        this.URL = environment.baseServerURL + "/security";
        this.ADMINISTRATION_URL = environment.baseServerURL + "/administration";
        this.currentCompanyId = this._authService.user.company.id;
        this.initService();
    }
    AgentService.prototype.buildURL = function (subPath) {
        return this.URL + "/user/agent/" + subPath;
    };
    AgentService.prototype.initService = function () {
        //Connect to socket server
        this.onUserConnected();
        //SET OFFLINE LISTENER
        this.setAgentOffline();
        //CHANGE COMPANY LISTENER
        this.changeCompany();
        //AGENT PERMISSIONS
        this.getAgentPermissions();
    };
    AgentService.prototype.availableAgentsByTopic = function (topic) {
        this.emit('availableAgents', {
            room: "availableAgents-" + this._authService.user.company.id,
            companyId: this._authService.user.company.id,
            queueType: topic
        });
    };
    AgentService.prototype.allAgentsAvailable = function (roomReference) {
        this.AllAvailableAgentsList = [];
        this.emit('allAvailableAgents', {
            room: roomReference || "allAvailableAgents-admin-" + this._authService.user.company.id,
            companyId: this._authService.user.company.id,
        });
    };
    AgentService.prototype.loadTopics = function () {
        var _this = this;
        this.getTopics().subscribe(function (topicList) {
            _this.topicIds = topicList.map(function (topic) { return topic.id; });
            _this._companyTopicList.next(topicList);
        });
    };
    AgentService.prototype.refreshAllAvailable = function () {
        var _this = this;
        clearTimeout(this._refreshTimer);
        this._refreshTimer = setTimeout(function () { _this.allAgentsAvailable(); }, 500);
    };
    AgentService.prototype.onUserConnected = function () {
        var _this = this;
        var email = this._authService.user.email;
        this.room = this._authService.user.email;
        var wssconfig = {
            url: environment.socketsURL + "/agent",
            options: {
                transports: ["websocket"],
                reconnection: true,
                autoConnect: true
            }
        };
        this.SocketAgent = new Socket(wssconfig);
        this.SocketAgent.ioSocket.auth = { email: email };
        this.initAgentListeners();
        //[Listener] : Agent Socket connect
        this.SocketAgent.on('connect', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //JOIN IN ROOMS
                        // El join va ANTES de consultar el estado: el servidor responde con un broadcast
                        // a la sala del asesor, asi que preguntar antes de unirse hace que la respuesta
                        // se pierda y el widget de disponibilidad quede en "cargando" indefinidamente.
                        this.joinAgentRooms(this._authService.user.company.id);
                        if (!(this._authService.user.role.id === 5)) return [3 /*break*/, 2];
                        if (!this.activeAgentStatus)
                            this.agentStatus({ emailAgent: this._authService.user.email, agentId: this._authService.user.id });
                        if (!!this._hasConnectedOnce) return [3 /*break*/, 2];
                        this._hasConnectedOnce = true;
                        return [4 /*yield*/, this.setSessionStatus({ agentId: this._authService.user.id, sessionStatus: { id: 5, name: "undefined" } })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.loadTopics();
                        this.refreshAllAvailable();
                        // Notify subscribers (e.g. admin agent-detail view) that the socket (re)connected,
                        // so they can re-join their reply room and re-query the resolved status.
                        this._onConnect.next();
                        return [2 /*return*/];
                }
            });
        }); });
        this.SocketAgent.on('disconnect', function () {
            _this._agentSessionStatus.next({ id: 5, name: "undefined" });
            _this._cachedAgent = null;
            _this._cachedAgentId = null;
        });
    };
    //AGENT SOCKET EMITER
    AgentService.prototype.emit = function (eventName, message) {
        if (this.SocketAgent) {
            this.SocketAgent.emit(eventName, message);
            return true;
        }
        return false;
    };
    //AGENT SOCKET LISTENER
    AgentService.prototype.listen = function (eventName) {
        var _this = this;
        if (this.SocketAgent) {
            return new Observable(function (subscriber) {
                _this.SocketAgent.on(eventName, function (data) {
                    subscriber.next(data);
                });
            });
        }
    };
    /**
     * Agents functions
     * =====================
     * - addAgent(agent)
     * - updateAgent(agent)
     * - getAgent(agentId)
     * - getAgentList()
     * - deleteAgent(agentId)
     */
    //agentLogout
    AgentService.prototype.agentLogout = function () {
        var _this = this;
        this.leaveAgentRooms(this._authService.user.company.id);
        this.changePushSession(0);
        var authUrl = environment.baseServerURL + "/auth/logout";
        this.http.post(authUrl, {}, {
            withCredentials: true
        }).subscribe(function (_) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.localService.removeJsonValue('userData');
                this.localService.removeJsonValue('messages');
                this.localService.removeJsonValue('sessionId');
                this.localService.removeJsonValue('superAdminCompany');
                sessionStorage.clear();
                this._authService.user = {};
                this.router.navigate(['/login']);
                window.location.reload();
                return [2 /*return*/];
            });
        }); }, function (error) { console.error(error); });
    };
    AgentService.prototype.setAgentOffline = function () {
        var _this = this;
        //Set offline
        if (this.SocketAgent && this._authService.user.role.id === 5) {
            this.sessionService.setOffline.subscribe(function (user) {
                _this.getAgent(user.id).subscribe(function (agentResult) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.setSessionStatus({ agentId: agentResult.id, sessionStatus: { id: 4, name: "offline" } })
                                //Redirección a login...
                            ];
                            case 1:
                                _a.sent();
                                //Redirección a login...
                                return [2 /*return*/, this.agentLogout()];
                        }
                    });
                }); });
            });
        }
    };
    AgentService.prototype.changeCompany = function () {
        var _this = this;
        this.sessionService.changeCompany.subscribe(function (newCompany) {
            _this.leaveAgentRooms(_this.currentCompanyId);
            _this.currentCompanyId = newCompany;
            _this.joinAgentRooms(_this.currentCompanyId);
            _this._cachedAgent = null;
            _this._cachedAgentId = null;
            _this.loadTopics();
            _this.refreshAllAvailable();
        });
    };
    AgentService.prototype.joinAgentRooms = function (company) {
        // Init agent ROOMS
        this.emit('joinRoom', "" + company);
        this.emit('joinRoom', "availableAgents-" + company);
        this.emit('joinRoom', "allAvailableAgents-admin-" + company);
        if (this._authService.user.role.id === 5) {
            this.emit('joinRoom', this.room);
        }
    };
    AgentService.prototype.leaveAgentRooms = function (company) {
        // Leave agent ROOMS
        this.emit('leaveRoom', "" + company);
        this.emit('leaveRoom', "availableAgents-" + company);
        this.emit('leaveRoom', "allAvailableAgents-admin-" + company);
        if (this._authService.user.role.id === 5)
            this.emit('leaveRoom', this.room);
    };
    AgentService.prototype.initAgentListeners = function () {
        var _this = this;
        //ALL AGENT AVALABLE
        this.listen('getAllAvailableAgents')
            .subscribe(function (allAgentsList) {
            _this.AllAvailableAgentsList = [];
            allAgentsList.map(function (agentList, index) {
                _this.AllAvailableAgentsList[index] = [];
                _this.AllAvailableAgentsList[index].push(agentList);
            });
        });
        //SET SESSION STATUS LISTENER
        this.listen('setSessionStatus')
            .subscribe(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var previousId, incomingId;
            return __generator(this, function (_a) {
                if (typeof response === 'object') {
                    previousId = this._agentSessionStatus.getValue().id;
                    incomingId = response.sessionStatus.id;
                    this._agentSessionStatus.next(response.sessionStatus);
                    if (previousId !== incomingId) {
                        this.refreshAllAvailable();
                        this.getAgentPermissions();
                    }
                }
                return [2 /*return*/];
            });
        }); });
    };
    AgentService.prototype.changePushSession = function (status) {
        var token = this.localService.getJsonValue('authToken');
        if (token)
            this.sysNotification.changeActiveSession({ auth: token, status: status }).subscribe();
    };
    // Get contact used in send Message
    AgentService.prototype.getContact = function (contactId) {
        var contactURL = environment.baseServerURL + "/operation/" + this._authService.user.company.id + "/contact/" + contactId;
        return this.http.get(contactURL, {
            withCredentials: true
        });
    };
    AgentService.prototype.transferContact = function (conversationReference) {
        var transferURL = environment.baseServerURL + "/operation/conversation/transfer";
        return this.http.put(transferURL, conversationReference, {
            withCredentials: true
        });
    };
    AgentService.prototype.closeConversation = function (conversationReference) {
        var closeURL = environment.baseServerURL + "/operation/conversation/close";
        return this.http.put(closeURL, conversationReference, {
            withCredentials: true
        });
    };
    AgentService.prototype.sendMessage = function (sendMessage) {
        var sendURL = environment.baseServerURL + "/operation/" + this._authService.user.company.id + "/sendMessageByChannel";
        return this.http.post(sendURL, sendMessage, {
            withCredentials: true
        });
    };
    AgentService.prototype.addAgent = function (agent) {
        return this.http.post(this.buildURL(''), agent, {
            withCredentials: true
        });
    };
    AgentService.prototype.updateAgent = function (agent) {
        return this.http.put(this.buildURL(agent.id), agent, {
            withCredentials: true
        });
    };
    AgentService.prototype.getAgent = function (agentId) {
        return this.http.get(this.buildURL(agentId + '/company/' + this._authService.user.company.id), {
            withCredentials: true
        });
    };
    AgentService.prototype.getAgentList = function () {
        return this.http.get(this.buildURL('company/' + this._authService.user.company.id), {
            withCredentials: true
        });
    };
    /**
     * Fuerza el estado offline de un agente (acción administrativa).
     * El body espera el estado como número plano, a diferencia del contrato
     * del socket (`AgentData.sessionStatus` es `{ id, name }`).
     * @param agentId - ID del agente a desconectar
     */
    AgentService.prototype.forceAgentOffline = function (agentId) {
        return this.http.put(this.buildURL(agentId + "/status"), { sessionStatus: 4 }, {
            withCredentials: true
        });
    };
    AgentService.prototype.deleteAgent = function (agentId) {
        return this.http.delete(this.buildURL('delete/' + agentId), {
            withCredentials: true
        });
    };
    /** Agent topics functions
     * =========================
     */
    AgentService.prototype.createTopic = function (topic) {
        var url = this.ADMINISTRATION_URL + "/" + this._authService.user.company.id + "/live/queue";
        return this.http.post(url, topic, {
            withCredentials: true
        });
    };
    AgentService.prototype.getGeneralQueue = function () {
        var url = this.ADMINISTRATION_URL + "/" + this._authService.user.company.id + "/live";
        return this.http.get(url, {
            withCredentials: true
        });
    };
    AgentService.prototype.getTopics = function () {
        var url = this.ADMINISTRATION_URL + "/" + this._authService.user.company.id + "/live/queue";
        return this.http.get(url, {
            withCredentials: true
        });
    };
    // CON OPORTUNIDAD DE MEJORA: Optimizar esta función para evitar múltiples llamadas HTTP y mejorar el rendimiento
    AgentService.prototype.getAgentTopics = function (agentId) {
        var url = this.URL + "/user/company/" + this._authService.user.company.id + "/getAgentUser/" + agentId;
        return this.http.get(url, {
            withCredentials: true
        });
    };
    AgentService.prototype.updateTopic = function (topic) {
        var url = this.ADMINISTRATION_URL + "/" + this._authService.user.company.id + "/live/queue/" + topic.id;
        return this.http.put(url, topic, {
            withCredentials: true
        });
    };
    AgentService.prototype.deleteTopic = function (id) {
        var url = this.ADMINISTRATION_URL + "/" + this._authService.user.company.id + "/live/queue/" + id;
        return this.http.delete(url, {
            withCredentials: true
        });
    };
    AgentService.prototype.agentStatus = function (_a) {
        var _this = this;
        var emailAgent = _a.emailAgent, agentId = _a.agentId;
        this.worker = new Worker('../workers/agent-status.worker', { type: 'module' });
        this.emitAgentStatus({ emailAgent: emailAgent, agentId: agentId });
        this.worker.onmessage = function (_a) {
            var data = _a.data;
            _this.activeAgentStatus = data;
        };
        this.worker.postMessage('Emit agent status');
        this.agentStatusTimer = setInterval(function () {
            _this.emitAgentStatus({ emailAgent: emailAgent, agentId: agentId });
        }, 120000); // each two minutes
    };
    AgentService.prototype.emitAgentStatus = function (_a) {
        var emailAgent = _a.emailAgent, agentId = _a.agentId;
        this.emit('agentStatus', { emailAgent: emailAgent, agentId: agentId });
    };
    AgentService.prototype.getTotalActiveConversationsByAgent = function (agentId) {
        var path = "/getTotalActiveConversationsByAgent/" + agentId;
        var url = environment.baseServerURL + "/operation/" + this._authService.user.company.id + path;
        return this.http.get(url, {
            withCredentials: true
        });
    };
    AgentService.prototype.createNewConversation = function (body) {
        var requestURL = environment.baseServerURL + "/operation/" + this._authService.user.company.id + "/createNewConversation";
        return this.http.post(requestURL, body, {
            withCredentials: true
        });
    };
    AgentService.prototype.exportConversation = function (contactId) {
        var url = this.ADMINISTRATION_URL + "/conversation/exportConversation";
        return new Observable(function (observer) {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ contactId: contactId }),
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error('Error en la respuesta del servidor');
                }
                var reader = response.body.getReader();
                var decoder = new TextDecoder();
                var chunks = [];
                // Leer los fragmentos de datos (stream)
                var processStream = function (_a) {
                    var done = _a.done, value = _a.value;
                    if (done) {
                        var combinedBlob = new Blob(chunks, {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });
                        observer.next(combinedBlob);
                        observer.complete();
                        return;
                    }
                    // Decodifica los fragmentos de datos
                    var decodedValue = decoder.decode(value, { stream: true });
                    if (decodedValue && decodedValue.includes('PING')) {
                        observer.next(decodedValue.replace(/^PING\s*/, ""));
                    }
                    else {
                        chunks.push(value); // Acumula los fragmentos binarios
                    }
                    // Sigue procesando el stream
                    return reader.read().then(processStream);
                };
                return reader.read().then(processStream);
            })
                .catch(function (err) {
                observer.error(err);
            });
        });
    };
    Object.defineProperty(AgentService.prototype, "companyTopicList", {
        get: function () {
            return this._companyTopicList.value;
        },
        set: function (topicList) {
            this._companyTopicList.next(topicList);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * AGENT SESSION STATUS
     * setSessionStatus({ agentId, sessionStatus }): Establece el estado de sesión del agente y emite el cambio a través del socket
     * agentSessionStatus: Obtiene o establece el estado de sesión actual del agente
     * @param {number} agentId - ID del agente
     * @param {sessionStatus} sessionStatus - Nuevo estado de sesión del agente
     */
    AgentService.prototype.setSessionStatus = function (_a) {
        var agentId = _a.agentId, sessionStatus = _a.sessionStatus;
        return __awaiter(this, void 0, void 0, function () {
            var _b, error_1, agent, agentData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        if (!(!this._cachedAgent || this._cachedAgentId !== agentId)) return [3 /*break*/, 2];
                        _b = this;
                        return [4 /*yield*/, this.getAgent(agentId).toPromise()];
                    case 1:
                        _b._cachedAgent = _c.sent();
                        this._cachedAgentId = agentId;
                        _c.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.error('[setSessionStatus] Error obteniendo datos del agente:', error_1);
                        if (!this._cachedAgent)
                            return [2 /*return*/, false];
                        return [3 /*break*/, 4];
                    case 4:
                        agent = this._cachedAgent;
                        agentData = {
                            firstName: agent.firstName,
                            sessionStatus: sessionStatus,
                            role: agent.role,
                            userId: agent.id,
                            token: this._authService.user.token,
                            email: agent.email,
                            companyId: agent.companyId,
                            queues: agent.queues || [],
                        };
                        return [2 /*return*/, this.emit('sessionStatus', agentData)];
                }
            });
        });
    };
    Object.defineProperty(AgentService.prototype, "agentSessionStatus", {
        get: function () {
            return this._agentSessionStatus.getValue();
        },
        set: function (status) {
            this._agentSessionStatus.next(status);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * FEATURE FLAGS
     * getAgentPermissions: Obtener los permisos del agente para funcionalidades específicas
     * get enableStartChatButton(): Obtener el valor actual de enableStartChatButton de forma síncrona
     * set enableStartChatButton(value: boolean): Establecer el valor de enableStartChatButton
     */
    AgentService.prototype.getAgentPermissions = function () {
        var _this = this;
        var _role = this._authService.user.role.id;
        var _userId = this._authService.user.id;
        if (_role === 5) {
            this.getAgent(_userId)
                .subscribe(function (agent) {
                if (agent) {
                    var canStart = agent.canStartConversation;
                    _this._enableStartChatButton.next(canStart);
                }
            });
        }
    };
    Object.defineProperty(AgentService.prototype, "enableStartChatButton", {
        /**
         * Obtener el valor actual de enableStartChatButton de forma síncrona
         */
        get: function () {
            return this._enableStartChatButton.value;
        },
        /**
         * Establecer el valor de enableStartChatButton
         */
        set: function (value) {
            this._enableStartChatButton.next(value);
        },
        enumerable: true,
        configurable: true
    });
    AgentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AgentService_Factory() { return new AgentService(i0.ɵɵinject(i1.SessionService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.LocalService), i0.ɵɵinject(i5.Router), i0.ɵɵinject(i6.SysnotificationService)); }, token: AgentService, providedIn: "root" });
    return AgentService;
}());
export { AgentService };
